import { customAxios } from './customAxios';

export function getBadpressAttachment(id) {
    const config = {
        headers: {
            Accept: '*/*',
            'AuthToken': JSON.parse(localStorage.getItem('token')),
        },
        responseType: 'blob',
    };

    return customAxios.get(`${process.env.REACT_APP_BACKEND_HOST}/adv/badpress/attachment/${id}`, config);
}
